<script>
  import { auth, db } from "../etc/firebase.js"
  import AesCtr from "../etc/aes-ctr.js"
  import {
    userStore,
    userGuaCount,
    guaRecordStore,
    selectedLanguage,
    // paymentResultObjString,
    // paymentStatus,
  } from "../etc/store.js"
  import PrivatePage from "./PrivatePage.svelte"
  import {
    btn_style_yellow_d2,
    btn_style_blue_d2,
    btn_style_teal,
    btn_style_orange_d2,
    xiyiSalt,
  } from "../etc/helpers.js"

  let btnStyle = "btn waves-effect waves-light indigo lighten-2 btn-single"
  let btnStyleNeedUpdate = btn_style_yellow_d2
  let btnStyleToUpdate = btn_style_blue_d2
  let btnStyleCancel = btn_style_orange_d2
  let docId = ""
  let firebaseUid = ""
  let createdDT = ""
  let userName = ""
  let password = ""
  let userAlias = ""
  let email = ""
  let country = ""
  let city = ""
  let phone = ""
  let subscriptionBeginOn = ""
  let subscriptionExpireOn = ""
  let lastPayment = 0
  let currencyType = ""
  let qiMonthlyGoal = 0
  let transactionRecords = []
  let timeToExpiration = 0
  let paymentIntentDT = 0
  let paymentIntent = false
  let intendedMemberType = ""
  let intendedTerm = ""

  let userNameNew
  let passwordNew
  let userAliasNew
  let emailNew
  let countryNew
  let cityNew
  let phoneNew
  let subscriptionBeginOnNew
  let subscriptionExpireOnNew
  let lastPaymentNew
  let currencyTypeNew
  let qiMonthlyGoalNew
  let transactionRecordsNew
  let timeToExpirationNew
  let subscriptionDetails = {}
  let editUserName = false
  let editUserAlias = false
  let editCountry = false
  let editCity = false
  let editPhone = false
  let editPassword = false
  let editQiMonthlyGoal = false
  let showPayment = false

  let guaCount = 0
  let myRecords = []
  let eachObj = {}

  let memberTypes = [
    "一般會員",
    "學生會員（我是全職學生、生活所費仍然依靠父母）",
  ]
  let memberType = ""
  let memberTypeFromDB = ""
  let subscriptionTerms = [1, 2, 3]
  let subscriptionTerm = ""
  let myName = ""
  let mySchool = ""
  let myMajor = ""
  let myYear = ""
  let myReasons = ""
  let studentTerm = 3
  //$: editAlias
  // Listen for auth status change
  let isLogin = false
  let isStudent = false
  let isRegular = false
  let canYouBuyMore = true

  // Listen for auth status change
  $: if ($userStore.isLogin == true) {
    isLogin = true

    // console.log("@ Account.$userStore.userInfo = ", $userStore.userInfo)

    // auth.onAuthStateChanged((user) => {
    //   if (user) {
    //     isLogin = true

    //     console.log("@ Account: getting user.uid = ", user.uid)

    // console.log("@ Account.processPayment : paymentStatus = ", $paymentStatus)
    // console.log(
    //   "@ Account.processPayment : result obj string = ",
    //   $paymentResultObjString
    // )
    docId = $userStore.userInfo.docId
    firebaseUid = $userStore.userInfo.firebaseUid
    userName = $userStore.userInfo.userName
    createdDT = $userStore.userInfo.createdDT
    userAlias = $userStore.userInfo.userAlias
    email = $userStore.userInfo.email
    country = $userStore.userInfo.country
    city = $userStore.userInfo.city
    phone = $userStore.userInfo.phone
    subscriptionBeginOn = $userStore.userInfo.subscriptionBeginOn
    subscriptionExpireOn = $userStore.userInfo.subscriptionExpireOn
    lastPayment = $userStore.userInfo.lastPayment
    currencyType = $userStore.userInfo.currencyType
    qiMonthlyGoal = $userStore.userInfo.qiMonthlyGoal
    memberTypeFromDB = $userStore.userInfo.memberType

    if ($userStore.userInfo.paymentIntent == true) {
      db.collection("xiyiMembers")
        .doc(docId)
        .update({
          paymentIntentDT: 0,
          paymentIntent: false,
          intendedMemberType: "",
          intendedTerm: "",
        })
        .then(() => {
          // console.log(
          //   "@ Account: successfully resetting payment intent info in XiYiMembers db."
          // )
        })
        .catch(() => {
          console.log(
            "@ Account: ***FAILED*** resetting payment intent info in XiYiMembers db."
          )
        })
    } else {
      // console.log("@ Account: payment intent info is clean.")
    }

    if ($userStore.userInfo.transactionRecords == undefined) {
      transactionRecords = []
    } else {
      transactionRecords = [...$userStore.userInfo.transactionRecords]
    }
    timeToExpiration = $userStore.userInfo.timeToExpiration
    // console.log(
    //   "@ Account if $userStore.isLogin: timeToExpiration = ",
    //   timeToExpiration
    // )
    checkAvailableTerms()
  } else {
    isLogin = false
  }
  // })

  function updateField(id, fieldName, newValue) {
    if (newValue == null) {
      alert("Your input is empty!")
      resetEditMode()
    } else {
      if (fieldName == "userName") {
        db.collection("xiyiMembers")
          .doc(id)
          .update({ userName: newValue })
          .then(() => {
            location.reload()
          })
        editUserName = false
      } else if (fieldName == "userAlias") {
        db.collection("xiyiMembers")
          .doc(id)
          .update({ userAlias: newValue })
          .then(() => {
            location.reload()
          })
        editUserAlias = false
      } else if (fieldName == "country") {
        db.collection("xiyiMembers")
          .doc(id)
          .update({ country: newValue })
          .then(() => {
            location.reload()
          })
        editCountry = false
      } else if (fieldName == "city") {
        db.collection("xiyiMembers")
          .doc(id)
          .update({ city: newValue })
          .then(() => {
            location.reload()
          })
        editCity = false
      } else if (fieldName == "phone") {
        db.collection("xiyiMembers")
          .doc(id)
          .update({ phone: newValue })
          .then(() => {
            location.reload()
          })
        editPhone = false
      } else if (fieldName == "qiMonthlyGoal") {
        db.collection("xiyiMembers")
          .doc(id)
          .update({ qiMonthlyGoal: newValue })
          .then(() => {
            location.reload()
          })
        editQiMonthlyGoal = false
      } else if (fieldName == "password") {
        //console.log("@ Account: user wants to update password to " + password)
        editPassword = false
      }
    }
  }

  function resetEditMode() {
    editUserName = false
    editUserAlias = false
    editCountry = false
    editCity = false
    editPhone = false
    editQiMonthlyGoal = false
    editPassword = false
  }

  // function convertToCSV(objArray) {
  //   var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray
  //   var str = ""

  //   for (var i = 0; i < array.length; i++) {
  //     var line = ""
  //     for (var index in array[i]) {
  //       if (line != "") line += ","

  //       line += array[i][index]
  //     }

  //     str += line + "\r\n"
  //   }

  //   return str
  // }

  // function treatComma(str) {
  //   return str.replace(",", "|")
  // }

  function obj2String(obj) {
    let str = ""

    //   console.log("@ Account.obj2String: I am getting an object ", obj)

    if (obj == undefined) {
      str = ""
    } else {
      // console.log(
      //   "@ Account.obj2String: I am getting an object typeof ",
      //   typeof obj
      // )
      // console.log("@ Account.obj2String: object length = ", obj.length)
      // console.log("@ Account.obj2String: object  = ", obj)

      if (obj.length == undefined) {
        str = obj.dt + ": " + obj.content
      } else {
        for (var i = 0; i < obj.length; i++) {
          if (i == obj.length - 1) {
            str = str + obj[i].dt + ": " + obj[i].content
          } else {
            str = str + obj[i].dt + ": " + obj[i].content + "; "
          }
        }
      }
    }

    // console.log("@ Account.obj2String: final str  = ", str)

    return str
  }

  function handleCSVDownload() {
    // console.log(
    //   "@ Account: handleCSVDownload with JSON.parse($guaRecordStore)... ",
    //   JSON.parse($guaRecordStore)
    // )

    let cleanedGuaRecords = cleanGuaRecordsForDownload($guaRecordStore)
    // console.log(
    //   "@ Account.handleCSVDownload: cleanedGuaRecords = ",
    //   cleanedGuaRecords
    // )

    // Preppare CSV file
    let header = "起卦人姓名\t起卦日期\t問題\t卦數\t類別\t標記\t解卦\t筆記\n"
    let csvString = header

    // build CSV from cleanedGuaRecords object array
    for (var i = 0; i < cleanedGuaRecords.length; i++) {
      let tmp_person = ""
      let tmp_dt = ""
      let tmp_question = ""
      let tmp_numbers = ""
      let tmp_cat = ""
      let tmp_tags = ""
      let tmp_explanation = ""
      let tmp_comment = ""

      // console.log(
      //   "@ Accocunt.handleCSVDownload: cleanedGuaRecords[i]['qiGuaPerson'] = ",
      //   cleanedGuaRecords[i]["qiGuaPerson"]
      // )

      tmp_person = cleanedGuaRecords[i]["qiGuaPerson"]
      tmp_dt = cleanedGuaRecords[i]["qiGuaDT"]
      tmp_question = cleanedGuaRecords[i]["question"]
      tmp_numbers = cleanedGuaRecords[i]["guaNumbers"]
      tmp_cat = cleanedGuaRecords[i]["category"]

      // console.log("@ Accocunt.handleCSVDownload: tmp_person = ", tmp_person)
      // console.log("@ Accocunt.handleCSVDownload: tmp_cat = ", tmp_cat)

      cleanedGuaRecords[i]["tag"] == undefined
        ? (tmp_tags = "")
        : (tmp_tags = cleanedGuaRecords[i]["tag"].toString())
      // : (tmp_tags = treatComma(cleanedGuaRecords[i]["tag"].toString()))

      tmp_explanation = obj2String(cleanedGuaRecords[i]["explanation"])

      tmp_comment = obj2String(cleanedGuaRecords[i]["comment"])

      // console.log(
      //   "@ Accocunt.handleCSVDownload: tmp_explanation = ",
      //   tmp_explanation
      // )
      // console.log("@ Accocunt.handleCSVDownload: tmp_comment = ", tmp_comment)

      csvString =
        csvString +
        tmp_person +
        "\t" +
        tmp_dt +
        "\t" +
        tmp_question +
        "\t" +
        tmp_numbers +
        "\t" +
        tmp_cat +
        "\t" +
        tmp_tags +
        "\t" +
        tmp_explanation +
        "\t" +
        tmp_comment +
        "\n"

      // console.log(
      //   "@ Accocunt.handleCSVDownload: so far csvString = ",
      //   csvString
      // )
    }

    //  console.log("@ Account: handleCSVDownload final csvString = ", csvString)

    var exportedFilenmae = "myGuaRecords.csv"

    var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" })
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, exportedFilenmae)
    } else {
      var link = document.createElement("a")
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob)
        link.setAttribute("href", url)
        link.setAttribute("download", exportedFilenmae)
        link.style.visibility = "hidden"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }

  function cleanGuaRecordsForDownload(fullStoreRecords) {
    let cleanedRecords = JSON.parse(fullStoreRecords)

    // console.log(
    //   "@ Account.cleanGuaRecordsForDownload: typeof cleanedRecords = ",
    //   typeof cleanedRecords
    // )

    for (var i = 0; i < cleanedRecords.length; i++) {
      delete cleanedRecords[i].firebaseUid
      delete cleanedRecords[i].recordDT
      delete cleanedRecords[i].guaType
      delete cleanedRecords[i].encryptionOn
      delete cleanedRecords[i].recorder
      delete cleanedRecords[i].show
      delete cleanedRecords[i].id

      // if convert qiGuaDT from epoch time to readable
      // check is qiGuaDT is a valid timestamp
      if (new Date(cleanedRecords[i].qiGuaDT).getTime() > 0) {
        cleanedRecords[i].qiGuaDT = new Date(cleanedRecords[i].qiGuaDT)
      }

      // now decrypt encrypted fields
      cleanedRecords[i].question = AesCtr.decrypt(
        cleanedRecords[i].question,
        xiyiSalt,
        256
      )
      if (cleanedRecords[i].explanation != undefined) {
        cleanedRecords[i].explanation.content = AesCtr.decrypt(
          cleanedRecords[i].explanation.content,
          xiyiSalt,
          256
        )
      }
      if (cleanedRecords[i].comment != undefined) {
        for (var c = 0; c < cleanedRecords[i].comment.length; c++) {
          cleanedRecords[i].comment[c].content = AesCtr.decrypt(
            cleanedRecords[i].comment[c].content,
            xiyiSalt,
            256
          )
        }
      }
    }

    // console.log(
    //   "@ Account.cleanGuaRecordsForDownload: cleanedRecords = ",
    //   cleanedRecords
    // )

    return cleanedRecords
  }

  // let showJSON = false
  function handleJSONDownload() {
    // console.log("@ Account: handleJSONDownload with myRecords... ", myRecords)
    // console.log(
    //   "@ Account: handleDownload with $guaRecordStore... ",
    //   $guaRecordStore
    // )

    let cleanedGuaRecords = cleanGuaRecordsForDownload($guaRecordStore)
    // console.log(
    //   "@ Account.handleJSONDownload: cleanedGuaRecords = ",
    //   cleanedGuaRecords
    // )

    // Download JSON a file
    let file_name = "myGuaRecords.json"
    let dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(cleanedGuaRecords))
    let dlAnchorElem = document.getElementById("downloadAnchorElem")
    dlAnchorElem.setAttribute("href", dataStr)
    dlAnchorElem.setAttribute("download", file_name)
    dlAnchorElem.click()
  }

  function proceedToPaymentProcess() {
    showPayment = !showPayment
  }

  $: if (memberType == "學生會員（我是全職學生、生活所費仍然依靠父母）") {
    isStudent = true
    isRegular = false
    subscriptionTerm = 3
  } else if (memberType == "一般會員") {
    isStudent = false
    isRegular = true
  } else {
    isStudent = false
    isRegular = false
  }

  let aDayinMs = 24 * 60 * 60 * 1000
  let aYearinDays = 365.25
  // Member can subscribe the most 3 years and 1 month
  let gracePeriod = 30
  //  $: if (timeToExpiration <= 0) {
  //$:
  function checkAvailableTerms(memberType) {
    canYouBuyMore = true
    subscriptionTerms = []
    // console.log(
    //   "@ Account: in checkAvailableTerms: original memberTypeFromDB : ",
    //   memberTypeFromDB
    // )
    // console.log(
    //   "@ Account: in checkAvailableTerms: now I got memberType : ",
    //   memberType
    // )
    // First time to buy, incoming memberTypeFromDB is always "unknown". Then user has option to choose
    // regular member or student member.
    if (memberTypeFromDB == "unknown" || memberTypeFromDB == undefined) {
      if (memberType == "一般會員") {
        subscriptionTerms = [1, 2, 3]
      } else {
        subscriptionTerms = [3]
      }
    } else if (memberTypeFromDB == "一般會員") {
      // User already declared to be regular member, can't be student member again.
      memberTypes = ["一般會員"]
      // console.log(
      //   "@ Account: in checkAvailableTerms: regular member checking days to expire : ",
      //   timeToExpiration
      // )
      if (timeToExpiration <= gracePeriod) {
        subscriptionTerms = [1, 2, 3]
        // console.log(
        //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
        //   subscriptionTerms
        // )
      } else if (
        timeToExpiration > gracePeriod &&
        timeToExpiration <= 1 * aYearinDays + gracePeriod
      ) {
        subscriptionTerms = [1, 2]
        // console.log(
        //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
        //   subscriptionTerms
        // )
      } else if (
        timeToExpiration > 1 * aYearinDays + gracePeriod &&
        timeToExpiration <= 2 * aYearinDays + gracePeriod
      ) {
        subscriptionTerms = [1]
        // console.log(
        //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
        //   subscriptionTerms
        // )
      } else {
        subscriptionTerms = []
        canYouBuyMore = false
        // console.log(
        //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
        //   subscriptionTerms
        // )
      }
    } else {
      // Existing student member renew can choose to be student again or regular member
      if (memberType == "一般會員") {
        // console.log(
        //   "@ Account: in checkAvailableTerms: student wants to change to regular : ",
        //   memberType
        // )
        if (timeToExpiration <= gracePeriod) {
          subscriptionTerms = [1, 2, 3]
          // console.log(
          //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
          //   subscriptionTerms
          // )
        } else if (
          timeToExpiration > gracePeriod &&
          timeToExpiration <= 1 * aYearinDays + gracePeriod
        ) {
          subscriptionTerms = [1, 2]
          // console.log(
          //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
          //   subscriptionTerms
          // )
        } else if (
          timeToExpiration > 1 * aYearinDays + gracePeriod &&
          timeToExpiration <= 2 * aYearinDays + gracePeriod
        ) {
          subscriptionTerms = [1]
          // console.log(
          //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
          //   subscriptionTerms
          // )
        } else {
          subscriptionTerms = []
          canYouBuyMore = false
          // console.log(
          //   "@ Account: in checkAvailableTerms: regular member subscriptionTerms : ",
          //   subscriptionTerms
          // )
        }
      } else {
        // console.log(
        //   "@ Account: in checkAvailableTerms: student wants to buy student account again : ",
        //   memberType
        // )

        if (timeToExpiration <= gracePeriod) {
          // console.log(
          //   "@ Account: in checkAvailableTerms: student account checking days to expire : ",
          //   timeToExpiration
          // )
          subscriptionTerms = [3]
          // console.log(
          //   "@ Account: in checkAvailableTerms: student member subscriptionTerms : ",
          //   subscriptionTerms
          // )
        } else {
          // console.log(
          //   "@ Account: in checkAvailableTerms: student account can't add more time : ",
          //   timeToExpiration
          // )
          subscriptionTerms = []
          // console.log(
          //   "@ Account: in checkAvailableTerms: student member subscriptionTerms : ",
          //   subscriptionTerms
          // )
          canYouBuyMore = false
        }
      }
    }
  }

  function handleStudentMemberInfo(memberType) {
    // console.log("In handleStudentMemberInfo and reseting subscriptionTerm")
    // console.log("In handleStudentMemberInfo, got memberType", memberType)
    // console.log(
    //   "In handleStudentMemberInfo: timeToExpiration =  ",
    //   timeToExpiration
    // )
    checkAvailableTerms(memberType)
    // console.log(
    //   "In handleStudentMemberInfo: after checkAvailableTerms,  subscriptionTerms =  ",
    //   subscriptionTerms
    // )
  }

  // **** ProcessPayment ****
  let termBasePrice = 60
  let amount = 0
  let schoolInfo = {}
  function processPayment(subscriptionTerm, memberType) {
    // console.log(
    //   "@ Account: member type " +
    //     memberType +
    //     " want to buy " +
    //     subscriptionTerm +
    //     " year(s)"
    // )

    if (
      confirm(
        "如果您確定要訂購/增購" +
          subscriptionTerm +
          "年，請按【OK】進入付款程續。"
      )
    ) {
      // Step 1:
      // console.log(
      //   "@ Account.processPayment: payment about to submit to Strip. Now let's update firebase payment intent attributes first"
      // )

      paymentIntentDT = new Date().getTime()
      paymentIntent = true
      intendedMemberType = memberType
      intendedTerm = subscriptionTerm

      if (intendedMemberType == "一般會員") {
        amount = intendedTerm * termBasePrice
      } else {
        amount = termBasePrice
        schoolInfo.myName = myName
        schoolInfo.mySchool = mySchool
        schoolInfo.myMajor = myMajor
        schoolInfo.myYear = myYear
        schoolInfo.myReasons = myReasons
      }
      // Save current member subscription info to firebase
      db.collection("xiyiMembers")
        .doc(docId)
        .update({
          paymentIntentDT: paymentIntentDT,
          paymentIntent: paymentIntent,
          intendedMemberType: intendedMemberType,
          intendedTerm: intendedTerm,
          intendedAmount: amount,
          schoolInfo: schoolInfo,
        })
        .then(() => {
          //location.reload()
          // console.log(
          //   "@ Account.paymentProcess: payment intention arrtibutes updated ",
          //   paymentIntentDT +
          //     ", " +
          //     paymentIntent +
          //     ", " +
          //     intendedMemberType +
          //     ", " +
          //     intendedTerm +
          //     " year."
          // )

          // Step 2: go charge in Stripe.
          // If successful, the success URL will be back to Account. Step 3 will be in check login and
          // check payment intent status
          // Test Stripe
          // var stripe = Stripe(
          //   "pk_test_51IHGxUBwl7igVdQM8VD5KqOPZdfJnCLxU3JmxKnrERpe4ZeapwRcF4gzBjDlgK4zPF9CmEEyu0OVIFoDmwfCc95J004xxmEdCG"
          // )

          // // student member 3-year
          // var studentPrice = "price_1IYZOnBwl7igVdQMqpfn5Jsy"
          // // regular member 1-year, 2-year, 3-year
          // var regularPrice = [
          //   "price_1IYP2yBwl7igVdQMqvOYh9Xe",
          //   "price_1IYZNqBwl7igVdQMKk7nNKi9",
          //   "price_1IYZOIBwl7igVdQM1xOq4diT",
          // ]

          // Life Stripe
          var stripe = Stripe(
            "pk_live_51IHGxUBwl7igVdQML9a5n1mySKAW2q95SlnrlVIW30Z9Q9vrqkprgQQMmUPh1EyWlfUVgRaoYkjsvNVJW1VU3Wjk00xe9AiTmS"
          )

          // student member 3-year
          var studentPrice = "price_1IYKxnBwl7igVdQMb2XgX9SC"
          // regular member 1-year, 2-year, 3-year
          var regularPrice = [
            "price_1IYKwfBwl7igVdQMpn4KtXH6",
            "price_1IYKx3Bwl7igVdQM8Ys3W8Hp",
            "price_1IYKxPBwl7igVdQMW6ZwoBxo",
          ]

          var selectedPrice = ""

          if (memberType == "一般會員") {
            selectedPrice = regularPrice[subscriptionTerm - 1]
          } else {
            selectedPrice = studentPrice
          }

          stripe
            .redirectToCheckout({
              lineItems: [
                {
                  price: selectedPrice, // Replace with the ID of your price
                  quantity: 1,
                },
              ],
              mode: "payment",
              successUrl: "https://www.xiyi.io/success",
              cancelUrl: "https://www.xiyi.io/cancel",
              // successUrl: "https://xiyi07.netlify.app/success",
              // cancelUrl: "https://xiyi07.netlify.app/cancel",
              //successUrl: "http://localhost:5000/success",
              //cancelUrl: "http://localhost:5000/cancel",
              customerEmail: email,
            })
            .then(function (result) {
              if (result.error) {
                alert(result.error.message)
              } else {
                // need some server side code to make this useful.
              }
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
            })
        })
    } else {
      location.assign("/cancel")
    }
  }
</script>

<svelte:head>
  <script src="https://js.stripe.com/v3/"></script>
</svelte:head>

{#if $selectedLanguage == "TW"}
  <div class="my-account" style="display: {showPayment ? 'none' : 'block'}">
    {#if isLogin}
      <h3>我的帳戶資料</h3>

      <!-- <p>Logged in as {userName}</p> -->

      <table class="account-tbl indigo lighten-5">
        <thead>
          <tr>
            <th class="item-field">資料</th>
            <th class="item-field">目前內容</th>
            <th>需要更新</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td class="item-field">Email</td>
            <td>{email}</td>
            <td><span>這是您的永久帳號，不能更改。</span></td>
          </tr>
          <tr>
            {#if timeToExpiration < 60 && timeToExpiration > 0}
              <td class="item-field exp-warning"
                ><strong>提醒您：離到期日只剩</strong></td
              >
              <td class="exp-warning"
                ><strong>
                  {Math.round((timeToExpiration + Number.EPSILON) * 100) / 100} 天</strong
                >
              </td>
            {:else if timeToExpiration > 0}
              <td class="item-field">離到期日還有</td>
              <td>
                {Math.round((timeToExpiration + Number.EPSILON) * 100) / 100} 天
              </td>
            {:else}
              <td class="item-field expire"><strong>已過期天數</strong></td>
              <td class="expire"
                ><strong>
                  {Math.round((timeToExpiration + Number.EPSILON) * 100) / 100} 天</strong
                >
              </td>
            {/if}
            <td
              ><button
                on:click={proceedToPaymentProcess}
                class={btnStyleToUpdate}>我要續訂</button
              ></td
            >
          </tr>
          <tr>
            <td class="item-field">密碼</td>
            <td>
              {#if editPassword}
                <input
                  class="white"
                  type="text"
                  bind:value={passwordNew}
                  placeholder={password}
                />
              {:else}
                **********
              {/if}
            </td>

            <td>
              {#if editPassword}
                <button
                  on:click={() => updateField(docId, "password", passwordNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editPassword = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">姓名</td>
            <td
              >{#if editUserName}
                <input
                  class="white"
                  type="text"
                  bind:value={userNameNew}
                  placeholder={userName}
                />
              {:else}
                {userName}
              {/if}</td
            >
            <td>
              {#if editUserName}
                <button
                  on:click={() => updateField(docId, "userName", userNameNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editUserName = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">代號</td>
            <td>
              {#if editUserAlias}
                <input
                  class="white"
                  type="text"
                  bind:value={userAliasNew}
                  placeholder={userAlias}
                />
              {:else}
                {userAlias}
              {/if}</td
            >
            <td>
              {#if editUserAlias}
                <button
                  on:click={() => updateField(docId, "userAlias", userAliasNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editUserAlias = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">國家/地區</td>
            <td>
              {#if editCountry}
                <input
                  class="white"
                  type="text"
                  bind:value={countryNew}
                  placeholder={country}
                />
              {:else}
                {country}
              {/if}
            </td>
            <td>
              {#if editCountry}
                <button
                  on:click={() => updateField(docId, "country", countryNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editCountry = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">城市</td>
            <td>
              {#if editCity}
                <input
                  class="white"
                  type="text"
                  bind:value={cityNew}
                  placeholder={city}
                />
              {:else}
                {city}
              {/if}
            </td>
            <td>
              {#if editCity}
                <button
                  on:click={() => updateField(docId, "city", cityNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editCity = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">電話</td>
            <td>
              {#if editPhone}
                <input
                  class="white"
                  type="text"
                  bind:value={phoneNew}
                  placeholder={phone}
                />
              {:else}
                {phone}
              {/if}
            </td>
            <td>
              {#if editPhone}
                <button
                  on:click={() => updateField(docId, "phone", phoneNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editPhone = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">每月起卦目標</td>
            <td>
              {#if editQiMonthlyGoal}
                <input
                  class="white"
                  type="text"
                  bind:value={qiMonthlyGoalNew}
                  placeholder={qiMonthlyGoal}
                />
              {:else}
                {qiMonthlyGoal}
              {/if}
            </td>
            <td>
              {#if editQiMonthlyGoal}
                <button
                  on:click={() =>
                    updateField(docId, "qiMonthlyGoal", qiMonthlyGoalNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editQiMonthlyGoal = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">我的卦例</td>
            <td>目前我在系統裡有【{$userGuaCount}】筆卦例</td>
            <td
              ><button on:click={handleJSONDownload} class={btn_style_teal}
                >下載 JSON</button
              >
              <button on:click={handleCSVDownload} class={btn_style_teal}
                >下載 CSV</button
              ></td
            >
          </tr>
          <tr>
            <td class="item-field">會員到期日</td>
            <td>{new Date(subscriptionExpireOn)}</td>
            <td
              ><button
                on:click={proceedToPaymentProcess}
                class={btnStyleToUpdate}>我要續訂</button
              ></td
            >
          </tr>

          <tr>
            <td class="item-field">上次繳費日與金額</td>
            <td class="item-field">{new Date(subscriptionBeginOn)}</td>
            <td>{currencyType}{lastPayment}</td>
          </tr>
          <tr>
            <td class="item-field">參加會員日</td>
            <td class="item-field">{new Date(createdDT)}</td>
            <td />
          </tr>
        </tbody>
      </table>
      <a id="downloadAnchorElem" style="display:none">:-)</a>
    {:else}
      <PrivatePage />
    {/if}
  </div>

  <div class="payment" style="display: {showPayment ? 'block' : 'none'}">
    <h4>訂購/增購付款流程</h4>
    <br />
    <div class="payment-process">
      <div class="payment-form-wrapper">
        <form
          class="payment-form"
          id="payment-form"
          on:submit|preventDefault={() =>
            processPayment(subscriptionTerm, memberType)}
        >
          <div class="member">
            <label>* 會員類別： </label>
            {#each memberTypes as item}
              <label class="member-type radio-item">
                <input
                  type="radio"
                  bind:group={memberType}
                  value={item}
                  on:click={() => handleStudentMemberInfo(item)}
                  required
                />
                <span class="checkbox-spacing">{item}</span>
              </label>
            {/each}
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {memberType == "" ? "" : "選定會員類別: " + memberType}</strong
              ></span
            >
          </div>
          <br />

          {#if isStudent == true}
            {#if canYouBuyMore == false}
              <h5 style="color:red;">
                抱歉！您的帳戶還有【{Math.round(
                  (timeToExpiration + Number.EPSILON) * 100
                ) /
                  100}】天才到期，因此不能接受您的加購，再買就超過3年一個月的上限了！
              </h5>
            {:else}
              <div
                class="student-info"
                style="display: {isStudent ? 'block' : 'none'}"
              >
                <h6>申請參加學生會員，請照實填寫以下表格：</h6>
                <div class="input-field">
                  <label>* 姓名：</label>
                  <input type="text" bind:value={myName} required />
                </div>
                <div class="input-field">
                  <label>* 學校名稱：</label>
                  <input type="text" bind:value={mySchool} required />
                </div>
                <div class="input-field">
                  <label>* 就讀科系：</label>
                  <input type="text" bind:value={myMajor} required />
                </div>
                <div class="input-field">
                  <label>* 年級：</label>
                  <input type="text" bind:value={myYear} required />
                </div>
                <div class="input-field">
                  <label>* 為什麼想要學易？</label>
                  <input type="text" bind:value={myReasons} required />
                </div>

                <div class="results blue lighten-4">
                  <h6>我再度確認我所填入的資料為正確：</h6>
                  <ul>
                    <li>姓名： {myName}</li>
                    <li>學校名稱： {mySchool}</li>
                    <li>就讀科系： {myMajor}</li>
                    <li>年級：{myYear}</li>
                    <li>為什麼想要學易？ {myReasons}</li>
                  </ul>
                </div>

                <br /><span class="blue-text darken-2"
                  ><strong>選定計畫: 學生會員3年 （US$：60）</strong></span
                >
              </div>
            {/if}
          {:else if isRegular == true}
            {#if canYouBuyMore == false}
              <h5 style="color:red;">
                抱歉！您的帳戶還有【{Math.round(
                  (timeToExpiration + Number.EPSILON) * 100
                ) /
                  100}】天才到期，因此不能接受您的加購，再買就超過3年一個月的上限了！
              </h5>
            {:else}
              <label>* 訂購/增購計畫（最多不超過3年）： </label>
            {/if}
            {#each subscriptionTerms as item}
              <label class="subscription-type radio-item">
                <input
                  type="radio"
                  bind:group={subscriptionTerm}
                  value={item}
                />
                <span class="checkbox-spacing">{item + "年"}</span>
              </label>
            {/each}
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {subscriptionTerm == ""
                  ? ""
                  : "選定計畫: " +
                    subscriptionTerm +
                    "年 （US$：" +
                    subscriptionTerm * 60 +
                    "）"}</strong
              ></span
            >
          {/if}

          <br /><br />

          {#if memberType != "" && subscriptionTerm != "" && subscriptionTerms.length != 0}
            <button class={btnStyleNeedUpdate + " btn-large"}
              >訂購/增購 {subscriptionTerm + "年 " + memberType}</button
            >
          {:else}
            <button disabled class={btnStyleNeedUpdate + " btn-large"}
              >訂購/增購 {subscriptionTerm + "年 " + memberType}</button
            >
          {/if}
        </form>
        <br />
      </div>
    </div>
  </div>
{:else}
  <!-- <h1>Add simplified Chinese section later.</h1> -->
  <div class="my-account" style="display: {showPayment ? 'none' : 'block'}">
    {#if isLogin}
      <h3>我的帐户资料</h3>

      <!-- <p>Logged in as {userName}</p> -->

      <table class="account-tbl indigo lighten-5">
        <thead>
          <tr>
            <th class="item-field">资料</th>
            <th class="item-field">目前内容</th>
            <th>需要更新</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td class="item-field">Email</td>
            <td>{email}</td>
            <td><span>这是您的永久帐号，不能更改。</span></td>
          </tr>
          <tr>
            {#if timeToExpiration < 60 && timeToExpiration > 0}
              <td class="item-field exp-warning"
                ><strong>提醒您：离到期日只剩</strong></td
              >
              <td class="exp-warning"
                ><strong>
                  {Math.round((timeToExpiration + Number.EPSILON) * 100) / 100} 天</strong
                >
              </td>
            {:else if timeToExpiration > 0}
              <td class="item-field">离到期日还有</td>
              <td>
                {Math.round((timeToExpiration + Number.EPSILON) * 100) / 100} 天
              </td>
            {:else}
              <td class="item-field expire"><strong>已过期天数</strong></td>
              <td class="expire"
                ><strong>
                  {Math.round((timeToExpiration + Number.EPSILON) * 100) / 100} 天</strong
                >
              </td>
            {/if}
            <td
              ><button
                on:click={proceedToPaymentProcess}
                class={btnStyleToUpdate}>我要续订</button
              ></td
            >
          </tr>
          <tr>
            <td class="item-field">密码</td>
            <td>
              {#if editPassword}
                <input
                  class="white"
                  type="text"
                  bind:value={passwordNew}
                  placeholder={password}
                />
              {:else}
                **********
              {/if}
            </td>

            <td>
              {#if editPassword}
                <button
                  on:click={() => updateField(docId, "password", passwordNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editPassword = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">姓名</td>
            <td
              >{#if editUserName}
                <input
                  class="white"
                  type="text"
                  bind:value={userNameNew}
                  placeholder={userName}
                />
              {:else}
                {userName}
              {/if}</td
            >
            <td>
              {#if editUserName}
                <button
                  on:click={() => updateField(docId, "userName", userNameNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editUserName = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">代号</td>
            <td>
              {#if editUserAlias}
                <input
                  class="white"
                  type="text"
                  bind:value={userAliasNew}
                  placeholder={userAlias}
                />
              {:else}
                {userAlias}
              {/if}</td
            >
            <td>
              {#if editUserAlias}
                <button
                  on:click={() => updateField(docId, "userAlias", userAliasNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editUserAlias = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">国家/地区</td>
            <td>
              {#if editCountry}
                <input
                  class="white"
                  type="text"
                  bind:value={countryNew}
                  placeholder={country}
                />
              {:else}
                {country}
              {/if}
            </td>
            <td>
              {#if editCountry}
                <button
                  on:click={() => updateField(docId, "country", countryNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editCountry = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">城市</td>
            <td>
              {#if editCity}
                <input
                  class="white"
                  type="text"
                  bind:value={cityNew}
                  placeholder={city}
                />
              {:else}
                {city}
              {/if}
            </td>
            <td>
              {#if editCity}
                <button
                  on:click={() => updateField(docId, "city", cityNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editCity = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">电话</td>
            <td>
              {#if editPhone}
                <input
                  class="white"
                  type="text"
                  bind:value={phoneNew}
                  placeholder={phone}
                />
              {:else}
                {phone}
              {/if}
            </td>
            <td>
              {#if editPhone}
                <button
                  on:click={() => updateField(docId, "phone", phoneNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editPhone = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">每月起卦目标</td>
            <td>
              {#if editQiMonthlyGoal}
                <input
                  class="white"
                  type="text"
                  bind:value={qiMonthlyGoalNew}
                  placeholder={qiMonthlyGoal}
                />
              {:else}
                {qiMonthlyGoal}
              {/if}
            </td>
            <td>
              {#if editQiMonthlyGoal}
                <button
                  on:click={() =>
                    updateField(docId, "qiMonthlyGoal", qiMonthlyGoalNew)}
                  class={btnStyleToUpdate}>更新</button
                >
                <button on:click={() => resetEditMode()} class={btnStyleCancel}
                  >取消更新</button
                >
              {:else}
                <button
                  on:click={() => {
                    resetEditMode()
                    editQiMonthlyGoal = true
                  }}
                  class={btnStyleNeedUpdate}>需要更新</button
                >
              {/if}
            </td>
          </tr>
          <tr>
            <td class="item-field">我的卦例</td>
            <td>目前我在系统里有【{$userGuaCount}】笔卦例</td>
            <td
              ><button on:click={handleJSONDownload} class={btn_style_teal}
                >下载 JSON</button
              >
              <button on:click={handleCSVDownload} class={btn_style_teal}
                >下载 CSV</button
              ></td
            >
          </tr>
          <tr>
            <td class="item-field">会员到期日</td>
            <td>{new Date(subscriptionExpireOn)}</td>
            <td
              ><button
                on:click={proceedToPaymentProcess}
                class={btnStyleToUpdate}>我要续订</button
              ></td
            >
          </tr>

          <tr>
            <td class="item-field">上次缴费日与金额</td>
            <td class="item-field">{new Date(subscriptionBeginOn)}</td>
            <td>{currencyType}{lastPayment}</td>
          </tr>
          <tr>
            <td class="item-field">参加会员日</td>
            <td class="item-field">{new Date(createdDT)}</td>
            <td />
          </tr>
        </tbody>
      </table>
      <a id="downloadAnchorElem" style="display:none">:-)</a>
    {:else}
      <PrivatePage />
    {/if}
  </div>

  <div class="payment" style="display: {showPayment ? 'block' : 'none'}">
    <h4>订购/增购付款流程</h4>
    <br />
    <div class="payment-process">
      <div class="payment-form-wrapper">
        <form
          class="payment-form"
          id="payment-form"
          on:submit|preventDefault={() =>
            processPayment(subscriptionTerm, memberType)}
        >
          <div class="member">
            <label>* 会员类别： </label>
            {#each memberTypes as item}
              <label class="member-type radio-item">
                <input
                  type="radio"
                  bind:group={memberType}
                  value={item}
                  on:click={() => handleStudentMemberInfo(item)}
                  required
                />
                <span class="checkbox-spacing">{item}</span>
              </label>
            {/each}
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {memberType == "" ? "" : "选定会员类别: " + memberType}</strong
              ></span
            >
          </div>
          <br />

          {#if isStudent == true}
            {#if canYouBuyMore == false}
              <h5 style="color:red;">
                抱歉！您的帐户还有【{Math.round(
                  (timeToExpiration + Number.EPSILON) * 100
                ) /
                  100}】天才到期，因此不能接受您的加购，再买就超过3年一个月的上限了！
              </h5>
            {:else}
              <div
                class="student-info"
                style="display: {isStudent ? 'block' : 'none'}"
              >
                <h6>申请参加学生会员，请照实填写以下表格：</h6>
                <div class="input-field">
                  <label>* 姓名：</label>
                  <input type="text" bind:value={myName} required />
                </div>
                <div class="input-field">
                  <label>* 学校名称：</label>
                  <input type="text" bind:value={mySchool} required />
                </div>
                <div class="input-field">
                  <label>* 就读科系：</label>
                  <input type="text" bind:value={myMajor} required />
                </div>
                <div class="input-field">
                  <label>* 年级：</label>
                  <input type="text" bind:value={myYear} required />
                </div>
                <div class="input-field">
                  <label>* 为什么想要学易？</label>
                  <input type="text" bind:value={myReasons} required />
                </div>

                <div class="results blue lighten-4">
                  <h6>我再度确认我所填入的资料为正确：</h6>
                  <ul>
                    <li>姓名： {myName}</li>
                    <li>学校名称： {mySchool}</li>
                    <li>就读科系： {myMajor}</li>
                    <li>年级：{myYear}</li>
                    <li>为什么想要学易？ {myReasons}</li>
                  </ul>
                </div>

                <br /><span class="blue-text darken-2"
                  ><strong>选定计划: 学生会员3年 （US$：60）</strong></span
                >
              </div>
            {/if}
          {:else if isRegular == true}
            {#if canYouBuyMore == false}
              <h5 style="color:red;">
                抱歉！您的帐户还有【{Math.round(
                  (timeToExpiration + Number.EPSILON) * 100
                ) /
                  100}】天才到期，因此不能接受您的加购，再买就超过3年一个月的上限了！
              </h5>
            {:else}
              <label>* 订购/增购计划（最多不超过3年）： </label>
            {/if}
            {#each subscriptionTerms as item}
              <label class="subscription-type radio-item">
                <input
                  type="radio"
                  bind:group={subscriptionTerm}
                  value={item}
                />
                <span class="checkbox-spacing">{item + "年"}</span>
              </label>
            {/each}
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {subscriptionTerm == ""
                  ? ""
                  : "选定计划: " +
                    subscriptionTerm +
                    "年 （US$：" +
                    subscriptionTerm * 60 +
                    "）"}</strong
              ></span
            >
          {/if}

          <br /><br />

          {#if memberType != "" && subscriptionTerm != "" && subscriptionTerms.length != 0}
            <button class={btnStyleNeedUpdate + " btn-large"}
              >订购/增购 {subscriptionTerm + "年 " + memberType}</button
            >
          {:else}
            <button disabled class={btnStyleNeedUpdate + " btn-large"}
              >订购/增购 {subscriptionTerm + "年 " + memberType}</button
            >
          {/if}
        </form>
        <br />
      </div>
    </div>
  </div>
{/if}

<style>
  .item-field {
    padding-left: 10px;
  }

  .expire {
    color: #ee2222;
  }

  .exp-warning {
    color: #ee8800;
  }
  .btn-single {
    margin-right: 5px;
    margin-bottom: 8px;
  }
  .checkbox-spacing {
    padding-left: 25px;
    padding-right: 25px;
  }
  .radio-item {
    border-left: 2px solid;
    padding-left: 10px;
  }
  ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
  .results {
    padding: 10px 15px;
  }
</style>
